export enum AGREEMENTS {
  RaceForTokens = 'race_for_tokens',
  PreLaunchAmbassador = 'pre_launch_ambassador',
  PreLaunchAgent = 'pre_launch_agent',
  ReferralV2 = 'referral_v2',
  AgentDeal = 'agent_deal_v3',
}
